import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

// TODO: use EventManagerPlugin after Angular 17 update

@Directive({
  selector: '[resize]',
  standalone: true,
})
export class ResizeDirective implements AfterViewInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public resize = new EventEmitter<DOMRect>();

  private observer: ResizeObserver;

  constructor(private element: ElementRef<HTMLElement>) {}

  public ngAfterViewInit(): void {
    this.observer = new ResizeObserver(() => {
      const rect = this.element.nativeElement.getBoundingClientRect();
      this.resize.emit(rect);
    });
    this.observer.observe(this.element.nativeElement);
  }

  public ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
